import { BlueButton, WhiteButton, YellowButton } from "../../Button/button";
import classes from "./popup.module.css";
import Edit from "../../../../assets/images/Onboarding/yellowEdit.svg";
import { useEffect, useState } from "react";
import { errorHandler } from "../../../../utils";
import { updateClientProfile } from "../../../../services/clientCalls";
import Video from "../../../../assets/images/TalentDashboard/video.png";
import { useNavigate } from "react-router";

const Popup2 = ({ data, Loop2, setData }) => {
  const [form, setForm] = useState(false);
  const [load, setLoad] = useState(false);
  const navigate = useNavigate();
  const [payload, setPayload] = useState({
    team: "No team yet",
    role: "Admin",
    position: "",
  });

  useEffect(() => {
    setPayload({
      team: "",
      role: "",
      position: "",
    });
  }, [data]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setLoad(true);
      const res = await updateClientProfile(payload);

      setData(res.data);
      setForm(false);
      setLoad(false);
    } catch (error) {
      setLoad(false);
      setForm(false);
      errorHandler(error, "Error");
    }
  };
  return (
    <div className={classes.main}>
      <h4>Videos</h4>
      <hr />

      {data?.videoUrl && (
        <div className={`flex ${classes.docs}`}>
          <img src={Video} alt="Video" />
          <a href={data.videoUrl} target="_blank" rel="noreferrer">
            Uploaded Video
          </a>
        </div>
      )}
      <video width="80%" height="80%">
        {/* <source src="mo" type="video/mp4"> */}
      </video>
      <hr />
      <>
        {!form && (
          <YellowButton
            extra={classes.edit}
            onClick={() => navigate("/talent-onboarding?stage=5")}
          >
            <img src={Edit} alt="Edit" /> Edit
          </YellowButton>
        )}
        {form && (
          <div className={`flex ${classes.btn}`}>
            <WhiteButton onClick={() => setForm(false)}>Cancel</WhiteButton>
            <BlueButton onClick={() => setForm(false)}>Save</BlueButton>
          </div>
        )}
      </>
    </div>
  );
};

export default Popup2;
